module.exports = __webpack_public_path__ + "img/draining-shelf.913a660c.jpg";